<template>
  <div class="menu-bar">
    <div class="selected-chain-container-fix" v-if="chainBtnFixed">
      <img class="fix-logo" src="../assets/img/mobile/discover.png">
      <div class="selected-chain-container-normal" @click="toggleChainSelector">
        <div class="selected-chain-container-normal-inner">
          <img class="chain" :src="require(`../assets/img/common/${activeChainLogoName}.png`)">
          <span>{{ active }}</span>
          <img v-if="chainSelectorShow" class="slide" src="../assets/img/mobile/slide_active.png">
          <img v-else class="slide" src="../assets/img/mobile/slide.png">
        </div>
      </div>
    </div>
    <div class="selected-chain-container-normal" @click="toggleChainSelector">
      <div class="selected-chain-container-normal-inner">
        <img class="chain" :src="require(`../assets/img/common/${activeChainLogoName}.png`)">
        <span>{{ active }}</span>
        <img class="slide" src="../assets/img/mobile/slide.png">
      </div>
    </div>
    <a class="github-container" target="_blank" href="https://github.com/dappcom/dapps/tree/main">
      <img src="../assets/img/mobile/github.png">
    </a>
    <a class="download-container" target="_blank" href="https://www.tokenpocket.pro/">
      <img src="../assets/img/mobile/download.png">
    </a>
    <div class="chain-container" v-if="chainSelectorShow">
      <div
        class="chain-item"
        :class="{'chain-item-active': item.section===active}"
        v-for="item in list"
        @click="tabActive(item.section)"
      >
        <img
            :src="require(`../assets/img/common/${item['unselected_logo']}.png`)"
            v-show="item.section!==active"
        >
        <img
            :src="require(`../assets/img/common/${item['selected_logo']}.png`)"
            v-show="item.section===active"
        >
        <span>{{ item.section }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "menu-bar",
  props: {
    list: {
      type: Array
    },
    active: {
      type: String
    },
    chainBtnFixed: {
      type: Boolean
    }
  },
  data() {
    return {
      chainSelectorShow: false
    }
  },
  computed: {
    activeChainLogoName() {
      return this.list.find(item=>item.section===this.active)['selected_logo']
    }
  },
  methods: {
    toggleChainSelector() {
      if (this.chainSelectorShow) {
        this.$emit('scrollHome')
      } else {
        this.$parent.chainBtnFixed = true
      }
      this.chainSelectorShow = !this.chainSelectorShow
    },
    tabActive(section) {
      this.$parent.active = section
      this.toggleChainSelector()
    }
  }
}
</script>

<style lang="less">
.menu-bar {
  font-size: 0;
  display: flex;
  margin-top: 0.5rem;

  .github-container, .download-container {
    height: 0.68rem;
    width: 0.68rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 0.16rem;
    margin-left: 0.2rem;

    img {
      height: 0.44rem;
    }
  }

  .selected-chain-container-fix {
    z-index: 9;
    position: fixed;
    top: 0;
    left: 0;
    height: 1.16rem;
    width: 100vw;
    background-color: #fbfcff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .fix-logo {
      height: 0.68rem;
      margin-left: 0.32rem;
    }

    .selected-chain-container-normal {
      margin-left: 0;
      margin-top: 0;
      margin-right: 0.32rem;
    }
  }

  .selected-chain-container-normal {
    display: inline-block;
    padding: 0.12rem 0.2rem 0.12rem 0.1rem;
    background: #ffffff;
    border-radius: 0.16rem;
    box-shadow: 0 0.02rem 0.04rem 0 rgba(39,97,231,0.03);
    margin-left: 0.32rem;

    .selected-chain-container-normal-inner {
      align-items: center;
      display: flex;
      .chain {
        height: 0.44rem;
      }
      span {
        font-weight: 400;
        font-size: 0.22rem;
        margin-left: 0.08rem;
      }
    }
    .slide {
      margin-left: 0.24rem;
      width: 0.16rem;
    }
  }

  .chain-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #2761e7;
    height: calc(100vh - 1.16rem);
    top: 1.16rem;

    .chain-item {
      width: 50%;
      height: 0.88rem;
      display: flex;
      align-items: center;
      float: left;

      img {
        width: 0.44rem;
        margin-left: 1rem;
      }

      span {
        margin-left: 0.16rem;
        font-weight: 400;
        font-size: 0.26rem;
        color: white;
      }
    }

    .chain-item-active {
      background-color: #f5f9ff;

      span {
        color: #101010;
      }
    }
  }
}
</style>
